import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';

import {
	CREATE_NOTIFICATION,
	GET_NOTIFICATIONS,
	UPDATE_NOTIFICATION,
	DELETE_NOTIFICATION,
	GET_ERRORS
} from './types';

const URL_GETNOTIFICATIONS    = process.env.REACT_APP_API_URL + services.getNotifications;
const URL_ADDNOTIFICATIONS    = process.env.REACT_APP_API_URL + services.createNotifications;
const URL_UPDATENOTIFICATIONS = process.env.REACT_APP_API_URL + services.updateNotifications;
const URL_DELETENOTIFICATIONS = process.env.REACT_APP_API_URL + services.deleteNotifications;

export const deleteNotifications = (id) => dispatch => {
	var URL = URL_DELETENOTIFICATIONS
	var data = {
		'id': id
	}
	axios
		.post(URL, data)
		.then(res => {
			dispatch({
				type: DELETE_NOTIFICATION,
				payload: {
					message: res.data.result
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const addNotifications = (title, description, image, days, hour, type, startDate, finalDate) => dispatch => {
	var data = {
		'title': title,
		'description': description,
		'image': image,
		'days': days,
		'hour': hour,
		'type': type,
		'startDate': startDate,
		'finalDate': finalDate
	}
	axios
		.post(URL_ADDNOTIFICATIONS, data)
		.then(res => {
			dispatch({
				type: CREATE_NOTIFICATION,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const updateNotifications = (id, title, description, image, days, hour, type, startDate, finalDate) => dispatch => {
	var data = {
		'id': id,
		'title': title,
		'description': description,
		'image': image,
		'days': days,
		'hour': hour,
		'type': type,
		'startDate': startDate,
		'finalDate': finalDate
	}
	axios
		.post(URL_UPDATENOTIFICATIONS, data)
		.then(res => {
			dispatch({
				type: UPDATE_NOTIFICATION,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const getNotifications = (page, type, limit = 15) => dispatch => {
	var filterURL = URL_GETNOTIFICATIONS
	var data = {
		'limit': limit,
		'page': page,
		'type': type,
		'sort_field': 'created_at',
		'sort': 'DESC'
	}
	axios
		.post(filterURL, data)
		.then(res => {
			dispatch({
				type: GET_NOTIFICATIONS,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const clearErrorBack = () => dispatch => {
	dispatch({
		type: GET_ERRORS,
		payload: {
			message: null
		}
	})
}